export var getFormattedEventName = function (name) {
    return "@data-subscriber/" + name;
};
export var getFormattedCustomEventName = function (name) {
    return "@custom-subscriber/" + name;
};
